import Button from '@mui/material/Button';
import { styled } from '@mui/material';

const StyledTextButton = styled(Button)(({ fontSize }) => ({
	padding: 0,
	margin: 0,
	justifyContent: 'start',
	color: 'inherit',
	background: 'none',
	fontSize,
	textTransform: 'none',
	textDecoration: 'underline',
	fontWeight: 'normal',
	border: 'none',
	'&:hover': {
		textDecoration: 'underline',
		background: 'none',
		border: 'none',
		color: 'inherit'
	}
}));

export default StyledTextButton;
